<template>
  <!--  备货商品维护页面-->
  <div class="commodityMaintenanceBox">
<!--    <div class="h-crumbOut">-->
<!--      <div class="h-crumbs">-->
<!--        <el-breadcrumb separator="|">-->
<!--          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>备货商品维护</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </div>-->
<!--    </div>-->
    <Breadtabsheader/>
    <!--    搜索开始-->
    <div class="h-piece h-mrt30">
      <div class="h-formBox">
        <el-form :inline="true" ref="q" :model="q" class="demo-form-inline h-formBorder" label-width="120px">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="产品大类" prop="levelCode">
              <brselectlazy category="product_level" :v="q.levelCode" v-model="q.levelCode"
                            :clearable="true"
                            style="width:100%"/>
            </el-form-item>
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model.trim="q.productName" placeholder="" @keyup.enter.native="handleFilter" maxlength="255" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品编号" prop="productId">
              <el-input v-model.trim="q.productId" placeholder="" @keyup.enter.native="handleFilter" maxlength="255" clearable></el-input>
            </el-form-item>

            <el-form-item label="直发/备货" prop="dirDelivery">
              <el-select v-model="q.dirDelivery" placeholder="请选择" style="width:100%;" filterable clearable>
                <el-option v-for="item in dDeliveryArr" :key="item.value"
                          :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            
            
          </div>
        </el-form>
        <!-- 修改 操作按钮位置 -->
        <div class="l-screenBox">
          <div class="l-retrieval">
          <!-- <el-form-item class="right-btn"> -->
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetForm('q')">重置</el-button>
              <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addEditDialog('','add')">新增
              </el-button>
            <!-- </el-form-item> -->
          </div>
        </div>
      </div>
    </div>
    <!--    搜索结束-->
    <!--    表格开始-->
    <div class="h-table h-mrt30 Ju">
      <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          style="width: 100%"
          :border="true"
          max-height="440"
      >
        <el-table-column
            fixed
            type="index"
            label="#"
            width="40">
        </el-table-column>
        <el-table-column
            prop="levelCodeName"
            label="产品大类"
            min-width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="text-align: left">
              {{scope.row.levelCodeName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="productName"
            label="产品名称"
            min-width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="text-align: left">
              {{scope.row.productName}}
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="productId"
            label="产品编号"
            min-width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div style="text-align: left">
              {{scope.row.productId}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="dirDelivery"
            label="直发"
            min-width="100"
            :formatter="formatter"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            prop="intDelivery"
            label="备货"
            min-width="100"
            :formatter="formatter"
            :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column
            label="操作"
            width="160"
            align="center"
            fixed="right"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="addEditDialog(scope.row,'edit')">
                修改
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="h-tableB h-mrt30">
      <div class="h-tableBL">
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                   style="margin-left:-20px;" @click="outexcel">批量导出
        </el-button>
        <el-button
            class="h-btn h-formBtn h-bgblueQ"
            icon="h-el-icon h-el-icon-export"
            @click="uploaddownexcelflagbtn">
          批量导入
        </el-button>
        <uploaddownexcel
            :visible.sync="uploaddownexcelflag"
            v-if="uploaddownexcelflag"
            clsname="orderSendTypeNImportExcel"
            :startrow="1"
            @callback="uploadExcelFilecallback"/>
      </div>
        <div class="h-pagination2">
          <el-pagination
            background
            @size-change="curChange"
            @current-change="curChange"
            :current-page.sync="q.pageNo"
            :page-sizes="[10,50,100,500]"
            :page-size="q.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="q.total"></el-pagination>
        </div>
      </div>
    </div>

    <!--    表格结束-->
    <!--    新增和编辑弹窗开始-->
    <el-dialog :close-on-click-modal="false" class="new-dialog" :visible.sync="dialogFormVisible">
      <!-- dialogImg -->
      <div class="h-dialogImg">
        <h3>{{ this.title }}</h3>
      </div>
      <el-form :model="addEditFrom" ref="addEditFrom" label-width="80px" :rules="rules" :inline="true" size="mini"
               class="addDeliveryForm">
        <el-form-item v-if="addEditFrom.optionsType === 'add'" label="产品大类" prop="levelCode">
          <brselectlazy category="product_level" :v="addEditFrom.levelCode" @change="callFun"
                        v-model="addEditFrom.levelCode"
                        :clearable="true"
                        />
        </el-form-item>
        <el-form-item v-else label="产品大类" prop="levelCodeName">
          <el-select v-model="addEditFrom.levelCodeName"  
                     disabled
                     clearable>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="productName">
          <!-- @change="productChange" -->
          <el-select v-model="addEditFrom.productName" placeholder="请选择"  @change="productChange"
                    filterable>
            <el-option v-for="item in productNameArr" :key="item.levelname"
                      filterable :label="item.levelname" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="产品编号" prop="productId">
          <el-select v-model="addEditFrom.productId" placeholder="请选择"  @change="productCode"
                    filterable>
            <el-option v-for="item in proudctLevelArr" :key="item.id"
                      filterable :label="item.id" :value="item">
            </el-option>
          </el-select>
          <!-- <el-input v-model.trim="addEditFrom.productId" disabled placeholder="" maxlength="255" clearable></el-input> -->
        </el-form-item>

        <el-form-item label="直发/备货" prop="dirDelivery">
          <el-select v-model="addEditFrom.dDeliveryIdelivery" placeholder="请选择"  @change="dDelivery"
                     clearable>
            <el-option v-for="item in dDeliveryArr2" :key="item.value"
                       :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="()=>dialogFormVisible=false">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <!--    新增和编辑弹窗结束-->
  </div>
</template>
<script>
import ss from '../../api/SystemService'
import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

export default {
  components: {
    uploaddownexcel,
  },
  name: "productManage",
  data() {
    return {
      //批量导入
      uploaddownexcelflag: false,
      dDeliveryArr: [  //直发备货
        {name: '全部', value: ''},
        {name: '直发', value: 1},
        {name: '备货', value: 0},
      ],
      dDeliveryArr2: [  //直发备货
        {name: '直发', value: 1},  //dDelivery
        {name: '备货', value: 0},   //iDelivery
        // {name: '直发/备货', value: 2},
      ],
      q: {  //搜索表单
        levelCode: '',//产品大类编号
        levelCodeName: '',//产品大类名称
        productName: '',//产品名称
        productId: '',//产品编码
        dirDelivery: '',//是否直发备货（0否1是）1代表直发  0 代表备货
        pageSize: 10,
        pageNo: 1,
        total: 0,

      },
      //新增和编辑
      addEditFrom: {
        levelCode: '',//产品大类编号
        levelCodeName: '',//产品大类名称
        productName: '',//产品名称
        productId: '',//产品id
        ddelivery: '',//是否直发备货（0否1是）1代表直发  0 代表备货
        dDeliveryIdelivery: '',//
      },
      rules: {
        levelCode: [
          {required: true, message: '请选择产品大类', trigger: 'blur'},
        ],
        productName: [
          {required: true, message: '请输入产品名称', trigger: 'blur'},
        ],
        ddeliveryIdelivery: [
          {required: true, message: '请选择直发/备货', trigger: 'blur'},
        ],
      },
      dialogFormVisible: false,//新增和编辑弹窗开关
      title: '备货商品新增',
      productNameArr: [],//弹窗中产品名称集合
      proudctLevelArr:[],
      tableData: [], //表格数据集合
    }
  },

  //加载页面默认执行
  created() {
    this.query();
    this.addEditFrom.dDeliveryIdelivery = '0'
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
  activated() {
    this.query();
  },


  methods: {
    curChange() {//点击分页调用
      this.query();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
    },
    //产品名称选择回调
    productChange(e) {
      if (e) {
        this.$set(this.addEditFrom, 'productName', e.levelname);//产品名称
        this.$set(this.addEditFrom, 'productId', e.id);//产品编码
      } else {
        this.$set(this.addEditFrom, 'productName', '');//产品名称
        this.$set(this.addEditFrom, 'productId', '');//产品编码
      }
    },
    productCode(e){
      if (e) {
        this.$set(this.addEditFrom, 'productId', e.id);//产品编码
        this.$set(this.addEditFrom, 'productName', e.levelname);//产品名称
      } else {
        this.$set(this.addEditFrom, 'productId', '');//产品编码
        this.$set(this.addEditFrom, 'productName', '');//产品名称
      }
    },
    callFun(obj) {
      let id = this.addEditFrom.levelCode;
      this.$set(this.addEditFrom, 'levelCodeName', obj.name); //产品大类名称
      this.$set(this.addEditFrom,'productId', obj.productCate)
      id && this.selectProduct2Cg(id)
    },
    //大类修改时，查询小类列表 v.type大类id-v,index-i  (产品名称下拉获取)
    selectProduct2Cg(id) {
      ss.ProService.product2OemSelect(id).then(rd => {
        this.productNameArr = rd;
        this.proudctLevelArr = rd
      })
    },
    // 直发/备货下拉选择
    dDelivery(e) {
      console.log("下拉选择")
      if (this.addEditFrom.dDeliveryIdelivery == 1) {
        this.$set(this.addEditFrom, 'dirDelivery', 1);//直发
        this.$set(this.addEditFrom, 'intDelivery', 0);//备货
      } else if (this.addEditFrom.dDeliveryIdelivery == 0) {
        this.$set(this.addEditFrom, 'dirDelivery', 0);//直发
        this.$set(this.addEditFrom, 'intDelivery', 1);//备货
      } 
    },
    //提交
    submit() {
      let obj = JSON.parse(JSON.stringify(this.addEditFrom))
      //新增
      if (this.addEditFrom.optionsType === 'add') {
        ss.chanpin.insertSendTypeN(obj).then(res => {
          if (res.f == true) {
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
            this.query();
          } else {
            this.$message.error(res.msg);
          }
        })
      } else if (this.addEditFrom.optionsType === 'edit') {
        //修改
        ss.chanpin.updateSendTypeN(obj).then(res => {
          if (res.f == true) {
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
            this.query();
          } else {
            this.$message.error(res.msg);
          }
        })
      }


    },
    //点击新增或编辑
    addEditDialog(row, type) {
      this.dialogFormVisible = true;
      if (type == 'edit') { //编辑
        this.title = '备货商品修改';
        this.$set(this.addEditFrom, 'id', row.id);
        this.$set(this.addEditFrom, 'optionsType', 'edit');
        this.$set(this.addEditFrom, 'levelCode', row.levelCode);//产品大类编号
        this.$set(this.addEditFrom, 'levelCodeName', row.levelCodeName);//产品大类编号
        this.$set(this.addEditFrom, 'productName', row.productName);//产品名称
        this.$set(this.addEditFrom, 'productId', row.productId);//产品名称编码
        this.$set(this.addEditFrom, 'dirDelivery', row.dirDelivery);//是否直发备货（0否1是）1代表直发  0 代表备货
        this.$set(this.addEditFrom, 'intDelivery', row.intDelivery);//是否直发备货（0否1是）1代表直发  0 代表备货
        if(row.intDelivery == '1'){
          console.log(row.dirDelivery)
          this.$set(this.addEditFrom, 'dDeliveryIdelivery', '备货');
        }else{
          this.$set(this.addEditFrom, 'dDeliveryIdelivery', '直发');
        }
      } else {
        this.title = '备货商品新增';
        this.proudctLevelArr = []
        this.addEditFrom.productId = ''
        console.log(this.title)
        if(this.addEditFrom.dDeliveryIdelivery == '0'){
          this.$set(this.addEditFrom, 'dirDelivery', 0);//直发
          this.$set(this.addEditFrom, 'intDelivery', 1);//备货
        }else{
          this.$set(this.addEditFrom, 'dirDelivery', 1);//直发
          this.$set(this.addEditFrom, 'intDelivery', 0);//备货
          //this.$set(this.addEditFrom, 'dirDelivery', '');//是否直发备货（0否1是）1代表直发  0 代表备货
        }
        this.$set(this.addEditFrom, 'dDeliveryIdelivery', '备货');//是否直发备货（0否1是）1代表直发  0 代表备货  2 代表全部
        this.$set(this.addEditFrom, 'optionsType', 'add');
        this.$set(this.addEditFrom, 'levelCode', '');//产品大类编号
        this.$set(this.addEditFrom, 'levelCodeName', '');//产品大类编号
        this.$set(this.addEditFrom, 'productName', '');//产品名称
      }

    },
    formatter(row, column) {
      let prop = column.property;   //获取当前列的prop设置的key
      if (row[prop] == 0) {
        return '否'
      } else if (row[prop] == 1) {
        return '是'
      } else {
        return ''
      }
    },
//导入Excel
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
      this.query();
    },
    uploadExcelFilecallback(rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },


    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.query();
    },


    //查询翻页
    query() {
      ss.chanpin.orderSendTypeNlectPage(this.q).then(res => {
        if (res.f == true) {
          this.q.total = res.obj.total;
          this.tableData = res.obj.records;

        } else {
          this.$message.error(res.msg);
        }
      })
    },


    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },


    handleSelectionChange(val) {

      console.log(val)
      this.multipleSelection = val;
    },


    //导表
    outexcel() {
      ss.chanpin.downloadExcelCommodity(this.q);
    },
  },

  mounted() {
    // this.status = sessionStorage.priceManage?sessionStorage.priceManage:1;
    // if(sessionStorage.priceManage != 2){
    // 	this.showOrhide = true;
    // }
  },
}
</script>
<style scoped>
.commodityMaintenanceBox > .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 3rem !important;
}
</style>
<style>
.Ju .h-btn.el-button.h-tableLink {
  padding: 0 0.05rem;
}

</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: 0;
    left: 0;
  }

  .step2 {
    top: 0;
    left: 0;
  }

  .step3 {
    top: 0;
    left: 0;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }

}
</style>
<!--弹窗样式开始-->
<style scoped>
.commodityMaintenanceBox > .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 3rem !important;
}

/deep/ .el-dialog__header {
  padding: 0
}

/deep/ .el-dialog {
  border-radius: 0.1rem;
  width: 7.89rem;
}

/deep/ .el-dialog__body {
  padding: 0;
}

/deep/ .el-dialog__header {
  background: #2785E7
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  height: 0.56rem;
  width: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  background-color: #fff;
  color: #015ba0;
  border-radius: 100%;
  font-size: 0.34rem;
}

.h-dialogImg {
  height: 1.62rem;
  background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
  background-size: 7.89rem;
  padding-left: 4.02rem;
}

.h-dialogImg h3 {
  text-align: left;
  padding: .6rem 0 0 0;
  font-size: 0.3rem;
  color: #fff;
  font-weight: normal;
  letter-spacing: 0.02rem;
}

.addDeliveryForm {
  padding: 0.54rem 0.28rem 0 0.25rem;
}
.addDeliveryForm /deep/ .el-form-item{
  width: 48%;
  float: left;
}
.addDeliveryForm /deep/ .el-form-item__label {
  width: 84px;
  font-size: 0.18rem;
  color: #4a4a4a;
  line-height: 0.28rem;
  vertical-align: top;
  padding-right: 5px;
  letter-spacing: 0;
  display: inline-block;
  text-align: right;
}
.addDeliveryForm /deep/ .el-form-item__content {
  width: 67%
}
.addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
  border-radius: 0;
  background: transparent;
  color: #868686;
  border: 0;
  border-bottom: 1px solid #dedede;
  height: 0.29rem;
  line-height: 0.28rem;
  padding-left: 0.15rem;
}

</style>
<!--弹窗样式结束-->

